<template>
  <div :class="[typeClass, { 'preserve-line-breaks': preserveLineBreaks }]">
    <slot />
  </div>
</template>

<!-- eslint-disable vue/block-lang -->
<script>
/* eslint-disable vue/component-api-style */
/**
 * Core typography component for displaying text in a body style.
 * Size Options: `1, 2`
 *
 * ```
 * import xBodyText from '@/components/shared/x-body-text'
 *
 * <x-body-text size="1">Lorem Ipsum...</x-body-text>
 * ```
 */
export default {
  name: 'XBodyText',
  props: {
    /**
     * Size of body text to display
     */
    size: {
      type: String,
      default: '1',
      validator: function (value) {
        return ['1', '2'].indexOf(value) !== -1
      },
    },
    /**
     * Display italic text
     */
    italic: {
      type: Boolean,
      default: false,
    },
    /**
     * Weight variant of type style
     */
    weight: {
      type: String,
      default: undefined,
      validator: function (value) {
        return ['medium', 'bold'].includes(value)
      },
    },
    /**
     * Preserve line-breaks in the body text
     */
    preserveLineBreaks: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    typeClass() {
      const italic = this.italic && !this.weight ? '-italic' : ''
      const weight = this.weight && this.size === '1' ? `-${this.weight}` : ''
      return `ys-text-body${this.size}${italic}${weight}`
    },
  },
}
</script>

<!-- eslint-disable vue/enforce-style-attribute -->
<style lang="scss">
.preserve-line-breaks {
  white-space: pre-wrap;
}
</style>
